export default __webpack_public_path__ + "static/webtrust-min-fdade0d5b1b8a6707b593429d84e1103.png";